export default function ProjectCard({
  index,
  title,
  keywords,
  startDate,
  endDate,
  link,
  description,
}) {
  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Guard: if index is ever missing/undefined, don't render "NaN" — fall back to a bullet.
  const numberLabel =
    typeof index === "number" && !Number.isNaN(index)
      ? String(index + 1).padStart(2, "0")
      : "•";

  return (
    <div className="hover-glow group relative bg-white/[0.02] border border-white/5 rounded-lg p-8 flex flex-col h-full overflow-hidden">
      <span className="absolute top-6 right-8 font-display text-5xl text-white/5 select-none">
        {numberLabel}
      </span>

      <p className="text-xs tracking-widest uppercase text-[#D4AF6A] mb-4">
        {month[new Date(startDate).getMonth()]}{" "}
        {new Date(startDate).getFullYear()} —{" "}
        {month[new Date(endDate).getMonth()]} {new Date(endDate).getFullYear()}
      </p>

      <h3 className="font-display text-2xl md:text-3xl mb-4 relative z-10">
        {title}
      </h3>

      <p className="text-[#D9D2C2] leading-relaxed mb-6 flex-1 relative z-10">
        {description}
      </p>

      <div className="flex flex-wrap gap-2 mb-6 relative z-10">
        {keywords.map((k, i) => (
          <span
            key={i}
            className="text-xs text-[#93A894] border border-white/10 px-2.5 py-1 rounded-full"
          >
            {k}
          </span>
        ))}
      </div>

      {link && !link.includes("empty") && (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="relative z-10 text-sm text-[#D4AF6A] self-start inline-flex items-center gap-1.5 group-hover:gap-2.5 transition-all duration-300"
        >
          View Project
          <svg className="w-3 h-3" viewBox="0 0 16 16" fill="none">
            <path
              d="M1 8h13M8 1l6 7-6 7"
              stroke="#D4AF6A"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      )}
    </div>
  );
}
